<script setup>
import { MediaUploaderButton, Label, Icon, Button, Textarea, Select, Input } from '@components'
import { watch } from 'vue'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useOnboarding } from '@store/onboarding'
const $onboarding = useOnboarding()

const site = prebook_admin.site
const $options = prebook_admin.options

const props = defineProps({
    provider: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
<div class="flex flex-col items-center gap-5">
    <div class="flex flex-col md:flex-row w-full gap-[48px] py-5 md:gap-12">
        <div title="Ensure to upload 900px x 220px full logo for better quality">
            <Label>Full Logo<div class="text-[#D92D20] inline-block">*</div></Label>
            <MediaUploaderButton class="mt-3" name="full_logo_url" :crop="true" :ratio="0"
                v-model="$settings.business.full_logo_url">
                <div class="p-2 rounded-lg border border-[#B692F6] border-dashed w-[253px]">
                    <Icon v-if="!$settings.business.full_logo_url" name="logoLight" height="68px" width="100%"
                        class="text-[#101828]" />
                    <img v-if="$settings.business.full_logo_url" :src="$settings.business.full_logo_url"
                        class="w-full max-h-full " />
                </div>
                <p class="mt-3 text-[#6941C6] text-sm font-semibold">Upload</p>
            </MediaUploaderButton>
        </div>
        <div title="Ensure to upload 320px x 320px logo for better quality">
            <Label>Logo Icon</Label>
            <MediaUploaderButton class="mt-3" name="logo_url" :crop="true" :ratio="1 / 1"
                v-model="$settings.business.logo_url">
                <div class="p-2 rounded-lg border border-[#B692F6] border-dashed">
                    <Icon v-if="!$settings.business.logo_url" name="logomark" width="72px" height="68px"
                        class="text-[#101828]" />
                    <img v-if="$settings.business.logo_url" :src="$settings.business.logo_url"
                        class="w-[72px] h-[68px]" />
                </div>
                <p class="mt-3 text-[#6941C6] text-sm font-semibold">Upload</p>
            </MediaUploaderButton>
        </div>
    </div>
    <div class="text-[#475467] text-sm font-medium w-full">
        You can upload two logo variants for better adaptations.
    </div>
    <div class="w-full" v-if="!props.provider">
        <Label>Company Name <div class="text-[#D92D20] inline-block">*</div></Label>
        <Input v-model="$settings.business.name" type="text" class="my-1.5"></Input>
        <Button type="secondary_color" v-if="!$settings.business.name" @click="$settings.business.name = site.name">Use
            {{ site.name }}</Button>
    </div>

    <div class="grid grid-cols-3 gap-5 w-full">
        <div class="w-full" v-if="props.provider">
            <Label>First Name <div class="text-[#D92D20] inline-block">*</div></Label>
            <Input v-model="$settings.business.provider_first_name" type="text" placeholder="Enter first name"
                class="my-1.5"></Input>
        </div>

        <div class="w-full" v-if="props.provider">
            <Label>Last Name <div class="text-[#D92D20] inline-block">*</div></Label>
            <Input v-model="$settings.business.provider_last_name" type="text" placeholder="Enter last name"
                class="my-1.5"></Input>
        </div>

        <div class="w-full" v-if="props.provider">
            <Label>Display Name <div class="text-[#D92D20] inline-block">*</div></Label>
            <Input v-model="$settings.business.provider_display_name" type="text" placeholder="Enter display name"
                class="my-1.5"></Input>
        </div>
    </div>
    <div class="w-full" v-if="props.provider">
        <Label>Bio</Label>
        <Textarea v-model="$settings.business.provider_bio" class="mt-1.5" placeholder="Enter bio"></Textarea>
    </div>

    <div class="w-full">
        <Label>{{ props.provider ? `${$settings.labels.service?.singular}` : 'Company' }} Type <div
                class="text-[#D92D20] inline-block">*</div></Label>
        <Select search v-model="$settings.business.type" :options="$options.business_types" class="my-1.5"></Select>
    </div>

    <div class="w-full" v-if="!props.provider">
        <Label>About Company</Label>
        <Textarea v-model="$settings.business.about" class="mt-1.5" placeholder="Enter a description"></Textarea>
    </div>
</div>
</template>


<style></style>